import styled from 'styled-components';

import { media } from '@/utils/mediaQueries';

/**
 * Pasek zaznaczenia jako pływająca pigułka przy dole ekranu, ten sam na desktopie i telefonie:
 * nie przesuwa listy w dół przy zaznaczaniu i jest pod ręką przy długich tabelach.
 */
export const BulkActionsBar = styled.div<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  position: fixed;
  left: 50%;
  bottom: calc(24px + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 60;
  width: max-content;
  min-width: 360px;
  max-width: calc(100vw - 48px);
  margin: 0;
  padding: 8px 8px 8px 10px;
  border-radius: 9999px;
  /* Accent-ink (DS), jak główne przyciski. */
  background: #111827;
  color: white;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.28);

  ${media.mobile} {
    left: 12px;
    right: 12px;
    bottom: calc(12px + env(safe-area-inset-bottom));
    transform: none;
    width: auto;
    min-width: 0;
    max-width: none;
  }
`;

export const BulkActionsLeft = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const BulkActionsCount = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color: white;
`;

export const BulkActionsRight = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
`;

/**
 * Same ikony w kołach 40×40; napis z treści przycisku jest schowany (font-size 0),
 * a jego opis niesie `aria-label`, pokazywany na desktopie jako podpowiedź po najechaniu.
 */
export const BulkActionButton = styled.button<{ $variant?: 'danger' | 'primary' }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  gap: 0;
  border: none;
  border-radius: 9999px;
  font-size: 0;
  white-space: nowrap;
  color: white;
  cursor: pointer;
  transition: background 0.2s ease;

  ${({ $variant }) => {
    switch ($variant) {
      case 'danger':
        return `
          background: #dc2626;
          &:hover:not(:disabled) { background: #b91c1c; }
        `;
      case 'primary':
        return `
          background: rgba(255, 255, 255, 0.2);
          &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.3); }
        `;
      default:
        return `
          background: rgba(255, 255, 255, 0.15);
          &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.25); }
        `;
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  /* Desktop: podpis ikony nad przyciskiem po najechaniu (na telefonie nie ma hovera). */
  &[aria-label]:hover::after {
    content: attr(aria-label);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 8px;
    border-radius: 6px;
    background: #111827;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
  }

  ${media.mobile} {
    &[aria-label]:hover::after {
      display: none;
    }
  }
`;
